import $ from 'jquery'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

function init() {}
function ready() {
  const simpleFadeIn = () => {
    const $targets = $('.js-fadein')
    $targets.each((_, el) => {
      ScrollTrigger.create({
        trigger: el,
        start: 'top 80%',
        onEnter: () => el.classList.add('is-active'),
      })
    })
  }

  const separateFadeIn = () => {
    const $targets = $('.js-fadein-separate')

    $targets.each((_, el) => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: el,
          start: 'top 80%',
        },
      })

      tl.call(
        () => {
          $(el).find('.js-fadein-separate__first').addClass('is-active')
        },
        [],
        0
      )

      tl.call(
        () => {
          $(el).find('.js-fadein-separate__second').addClass('is-active')
        },
        [],
        '>0.4'
      )
    })
  }

  const gridFadeIn = () => {
    const $target = $('.js-grid-fadein')
    const $items = $target.children()

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: $target.get(),
        start: 'top 80%',
      },
    })

    Array.from($items).forEach((item) => {
      tl.call(
        () => {
          $(item).addClass('is-active')
        },
        [],
        '>0.15'
      )
    })
  }

  const topBusinessFadeIn = () => {
    const $target = $('.js-top-business-fadein')
    const $heading = $target.find('.js-top-business-fadein__heading')
    const $body = $target.find('.js-top-business-fadein__body')
    const $items = $target.find('.js-top-business-fadein__items').children()

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: $target.get(),
        start: 'top 80%',
      },
    })

    tl.call(
      () => {
        $heading.addClass('is-active')
      },
      [],
      0
    )

    tl.call(
      () => {
        $body.addClass('is-active')
      },
      [],
      '>0.5'
    )

    Array.from($items).forEach((item) => {
      tl.call(
        () => {
          $(item).addClass('is-active')
        },
        [],
        '>0.15'
      )
    })
  }

  const forwardCardsFadeIn = () => {
    const $target = $('.js-forward-cards')
    if (!$target.length) return
    const $items = $target.children()

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: $target.get(0),
        start: 'top 80%',
      },
    })

    Array.from($items).forEach((item) => {
      tl.call(
        () => {
          $(item).addClass('is-active')
        },
        [],
        '>0.2'
      )
    })
  }

  const businessGridFadeIn = () => {
    const $target = $('.js-business-grid')
    if (!$target.length) return
    const $items = $target.children()

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: $target.get(0),
        start: 'top 80%',
      },
    })

    Array.from($items).forEach((item) => {
      tl.call(
        () => {
          $(item).addClass('is-active')
        },
        [],
        '>0.1'
      )
    })
  }

  simpleFadeIn()
  separateFadeIn()
  gridFadeIn()
  topBusinessFadeIn()
  forwardCardsFadeIn()
  businessGridFadeIn()

  /*
  {scroll-behavior: smooth} とScrollTriggerの相性が悪く、ページ遷移時アンカーリンクへのスクロールが動かない（トップへ戻されてしまう）
  そのため一度{scroll-behavior: auto}を指定後、アンカー位置へ移動してからauto指定を解除する。
  */
  const hash = location.hash
  if (hash) {
    document.documentElement.style.scrollBehavior = 'auto'
    const hashTarget = document.getElementById(hash.replace('#', ''))
    hashTarget.scrollIntoView()
    document.documentElement.style.scrollBehavior = ''
  }
}

export default {
  init() {
    init()
    $(function () {
      ready()
    })
  },
}
